import { hubspotCalendarUiConstaints } from '@constants/hubspot-calendar-ui';

const setOpen = value => {
    return { type: hubspotCalendarUiConstaints.SET_HUBSPOT_CALENDAR_OPEN, payload: value };
};

export const hubspotCalendarUiActions = {
    setOpen,
};
